// extracted by mini-css-extract-plugin
module.exports = {"Filters":"Filters_Filters__2gQnm","SearchInput":"Filters_SearchInput__VqEoX"};